export default __webpack_public_path__ + "static/media/tempLogo.5ba1598f.png";